module.exports = __webpack_public_path__ + "img/small-abstract-6.b8da5e0.svg";